import React from 'react';
import { motion } from 'framer-motion';

const MetricsSection = () => {
  const metrics = [
    { value: "850+", label: "Professionnels certifiés" },
    { value: "45+", label: "Programmes certifiés" },
    { value: "12M €", label: "Projets réalisés" },
    { value: "15 ans", label: "D\'excellence" }
  ];

  return (
    <div className="relative z-20 max-w-6xl mx-auto px-4 -mt-20 mb-10">
      <motion.div 
        initial={{ opacity: 0, y: 30 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        className="bg-white rounded-2xl shadow-[0_20px_50px_rgba(0,0,0,0.1)] border border-gray-100 p-8 md:p-12"
      >
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-8 md:gap-12 divide-x-0 md:divide-x divide-gray-100">
          {metrics?.map((metric, index) => (
            <div key={index} className="flex flex-col items-center text-center px-4">
              <motion.span 
                initial={{ scale: 0.5 }}
                whileInView={{ scale: 1 }}
                transition={{ type: "spring", damping: 12, delay: index * 0.1 }}
                className="text-3xl md:text-4xl font-black text-[#96121D] mb-2 tracking-tight"
              >
                {metric?.value}
              </motion.span>
              <span className="text-[11px] md:text-xs uppercase tracking-[0.15em] font-bold text-gray-400 leading-tight">
                {metric?.label}
              </span>
              
              {/* Petite barre d'accentuation discrète sous le label */}
              <div className="w-6 h-0.5 bg-[#9B8E57]/30 mt-3 rounded-full"></div>
            </div>
          ))}
        </div>
      </motion.div>
      {/* Optionnel : Une petite phrase de réassurance juste en dessous du bloc */}
      <p className="text-center mt-6 text-gray-400 text-sm font-medium italic opacity-70">
        Chiffres audités et mis à jour pour l'exercice 2024
      </p>
    </div>
  );
};

export default MetricsSection;